export const table = {
    primaryData: [
        {
            title: "ID",
            value: "id",
        },
        {
            title: "Admission Number",
            value: "admissionNumber",
        },
        {
            title: "Academic Year Profile Name",
            value: "narayanaAcademicYearProfileName",
        },
        {
            title: "User Name",
            value: "userName",
        },
        {
            title: "Academic Year",
            value: "academicYearName",
        },
        {
            title: "Package Name",
            value: "packageName",
        },
        {
            title: "Package Schedule Name",
            value: "packageScheduleName",
        },
        {
            title: "Recorded Video Max Visible Date",
            value: "recordedVideoMaxVisibleDate",
            name: "recordedVideoMaxVisibleDate"
        },
    ],
    secondaryData: [
        {
            title: "Is Join Clicked",
            value: "isJoinClicked",
        },
        {
            title: "Is Watch Now Clicked",
            value: "isWatchNowClicked",
        },
        {
            title: "Is Attended",
            value: "isAttended",
        },
        {
            title: "Created At",
            value: "createdAt",
        },
        {
            title: "Updated At",
            value: "updatedAt",
            name: "updatedAt"
        },
    ],
};